import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=f7bd52d6&scoped=true&"
import script from "./Commissions.vue?vue&type=script&lang=js&"
export * from "./Commissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bd52d6",
  null
  
)

export default component.exports